import * as yup from 'yup'
import { TFunction } from 'react-i18next'

export function buildValidationSchema(t: TFunction): yup.AnyObjectSchema {
  return yup
    .object()
    .shape({
      name: yup
        .string()
        .label(t('badge.form.name'))
        .max(30, ({ label }) =>
          t('validations.maxLength', { label, maxLength: 30 })
        ),
    })
    .required()
}
